<script>
import { ToolSuggestion } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Suggestion',
      verboseName: 'Sugestia',
      verboseNamePlural: 'Sugestie',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'Nazwa' },
        { prop: 'email', label: 'Email' }
      ]
    }
  },
  computed: {
    service() {
      return ToolSuggestion
    }
  }
}
</script>
